import React, { Component } from 'react';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import PendingMessageApprovalListPageUI from './PendingMessageApprovalListPageUI';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';

class PendingMessageApprovalListPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      pendingMessageList: null,
      selectedMessage: null,
      selectedMessageId: null,
      messageCreateMode: false,
      messageUpdateMode: false,
      sendSubmitted: false,
      sendSuccessMsg: null,
      sendErrorList: null,
      deleteSubmitted: false,
      deleteSuccessMsg: null,
      deleteErrorList: null,
      internalSendSubmitted: false,
      internalSendSuccessMsg: null,
      internalSendErrorList: null,
      docsUploadMode: false,
      uploadSubmitted: false,
      uploadSuccessMsg: null,
      uploadErrorList: [],
      deleteFileMode: false,
      createMode: false,
      updateEmailMode: false,
    };
  }

  render() {
    return (
      <PendingMessageApprovalListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        pendingMessageList={this.state.pendingMessageList}
        onRefreshClick={this.onRefreshClick}
        selectedMessage={this.state.selectedMessage}
        selectedEmail={this.state.selectedEmail}
        selectedMessageId={this.state.selectedMessageId}
        messageCreateMode={this.state.messageCreateMode}
        onCreateMessageClick={() => { this.setState({ messageCreateMode: true }) }}
        onCreateMessageCancel={() => { this.setState({ messageCreateMode: false }) }}
        messageUpdateMode={this.state.messageUpdateMode}
        onUpdateMessageClick={this.onUpdateMessageClick}
        onUpdateMessageCancel={() => { this.setState({ messageUpdateMode: false }) }}
        sendSubmitted={this.state.sendSubmitted}
        sendSuccessMsg={this.state.sendSuccessMsg}
        sendErrorList={this.state.sendErrorList}
        onSendClick={this.onSendClick}
        deleteSubmitted={this.state.deleteSubmitted}
        deleteSuccessMsg={this.state.deleteSuccessMsg}
        deleteErrorList={this.state.deleteErrorList}
        onDeleteClick={this.onDeleteClick}
        internalSendSubmitted={this.state.internalSendSubmitted}
        internalSendSuccessMsg={this.state.internalSendSuccessMsg}
        internalSendErrorList={this.state.internalSendErrorList}
        onSendNoticeToInternalClick={this.onSendNoticeToInternalClick}
        //
        docsUploadMode={this.state.docsUploadMode}
        onDocsUploadClick={this.onDocsUploadClick}
        onDocsUploadCancel={() => { this.setState({ docsUploadMode: false }) }}
        onDocsUpload={this.onDocsUpload}
        ///
        yearMonth={this.state.yearMonth}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        //
        deleteFileMode={this.state.deleteFileMode}
        selectedFile={this.state.selectedFile}
        onFileDeleteClick={this.onFileDeleteClick}
        //
        onDocDownloadClick={this.onDocDownloadClick}
        //
        onDeleteEmailClick={this.onDeleteEmailClick}
        //
        createMode={this.state.createMode}
        onAddEmailClick={this.onAddEmailClick}
        onAddEmailCancel={() => { this.setState({ createMode: false }) }}
        //
        updateEmailMode={this.state.updateEmailMode}
        onUpdateEmailClick={this.onUpdateEmailClick}
        onUpdateEmailCancel={() => { this.setState({ updateEmailMode: false }) }}
      />
    );
  }

  componentDidMount() {
    let context = this.props.context;
    this.getPendingMessageApprovals(context, '', '');
  }

  onUpdateMessageClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('message-approval-id');
    let selectedMessage = this.state.pendingMessageList.filter(msg => msg.messageApprovalId === messageApprovalId)[0];
    this.setState({ messageUpdateMode: true, selectedMessage: selectedMessage, selectedMessageId: selectedMessage.selectedMessageId });
  };
  onAddEmailClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('message-approval-id');
    let selectedMessage = this.state.pendingMessageList.filter(msg => msg.messageApprovalId === messageApprovalId)[0];
    this.setState({ createMode: true, selectedMessage: selectedMessage, selectedMessageId: selectedMessage.selectedMessageId });
  };
  onUpdateEmailClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('data-message-approval-id');
    let selectedEmail = event.currentTarget.getAttribute('data-selected-email');
    let selectedMessage = this.state.pendingMessageList.filter(msg => msg.messageApprovalId === messageApprovalId)[0];


    if (!messageApprovalId || !selectedEmail) {
      console.error("Error: Message Approval ID or Old Email is missing");
      return;
    }

    this.setState({
      updateEmailMode: true,
      selectedMessage: selectedMessage, selectedMessageId: selectedMessage.selectedMessageId, selectedEmail: selectedEmail,
    });
  };

  onPreviousClick = () => {
    let context = this.props.context
    this.getPendingMessageApprovals(context, this.state.previousYear, this.state.previousMonth)
  }
  onNextClick = () => {
    let context = this.props.context
    this.getPendingMessageApprovals(context, this.state.nextYear, this.state.nextMonth)
  }

  getPendingMessageApprovals(context, year, month) {
    year = year === undefined ? '' : year
    month = month === undefined ? '' : month
    let cacheManager = new CacheManager({
      resource: `/api/su/messages/approvals`,
      cacheKey: CacheKeys.PendingMessageApprovals(year, month),
      callback: this.getPendingMessageApprovalsCallback,
      ttlInSecs: 600,
    });

    CacheManager.removeObject(CacheKeys.PendingMessageApprovals(year, month));

    cacheManager.getObject2(context, {}, { year: year, month: month });
  }

  getPendingMessageApprovalsCallback = (response) => {
    if (!response.messageApprovalList) {
      console.error('No messageApprovalList in response:', response);
      response.messageApprovalList = [];
    }

    console.log('Original response list:', response.messageApprovalList);

    let pendingMessageList = response.messageApprovalList.filter(message => {
      return message &&
        message.pendingStatus === "pending" &&
        message.approvalType !== "whatsapp" &&
        message.approvalType !== "customerServiceEmail";
    });

    console.log('Filtered list count:', pendingMessageList.length);

    this.setState({
      messageApprovalList: response.messageApprovalList,
      pendingMessageList: pendingMessageList,
      errorList: response.errorList,
      yearMonth: response.yearMonth,
      year: response.yearMonth.year,
      month: response.yearMonth.month,
      previousYear: response.yearMonth.prevYear,
      previousMonth: response.yearMonth.prevMonth,
      nextYear: response.yearMonth.nextYear,
      nextMonth: response.yearMonth.nextMonth
    });
  };

  onDocsUploadClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('message-approval-id');
    this.setState({ docsUploadMode: true, selectedMessageId: messageApprovalId }, () => {
      // Log after state is updated
      console.log("selected id:", this.state.selectedMessageId);
    });
  }

  onDeleteEmailClick = (event) => {
    const messageApprovalId = event.target.getAttribute('data-message-id');
    const email = event.target.getAttribute('data-email');

    if (!messageApprovalId || !email) {
      console.error('Message Approval ID or Email is missing');
      return;
    }

    this.setState({
      deleteSubmitted: true,
      deleteErrorList: [],
      selectedMessageId: messageApprovalId,
    });

    RestApiUtils.delete(
      this.props.context,
      `/api/su/messages/approvals/${messageApprovalId}/email/${email}`,
      this.onDeleteEmailCallback,
      {}
    );
  };

  onDeleteEmailCallback = (response) => {
    let errorList = [];
    if (response.errorList && response.errorList.length > 0) {
      errorList = response.errorList.map((error) => error.message);
    }

    this.setState({
      deleteSuccessMsg: response.success,
      deleteErrorList: errorList,
      deleteSubmitted: false,
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ deleteSuccessMsg: null, deleteErrorList: [] });
        this.onRefreshClick('noBusy');
      }, 2000);
    }
  };

  onDocsUpload = (fileId, fileName, fileType, fileSize) => {
    this.setState({
      uploadSubmitted: true,
      uploadSuccessMsg: null,
      uploadErrorList: [],
    });

    RestApiUtils.post(this.props.context,
      `/api/su/messages/approvals/${this.state.selectedMessageId}/validation`,
      this.onDocsUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    });
  }


  onDocsUploadCallback = (response) => {
    this.setState({ uploadSubmitted: false });
    let errorList = [];
    response.errorList.forEach(error => {
      errorList.push(error.message);
    });

    this.setState({
      uploadSuccessMsg: response.success,
      uploadErrorList: errorList,
    });

    this.onRefreshClick('noBusy');

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          uploadSuccessMsg: null
        });
      }, 2000);
    }
  }

  onDocDownloadClick = (event) => {
    let messageApprovalId = event.currentTarget.getAttribute('message-approval-id');
    let fileName = event.currentTarget.getAttribute('data-file-name');

    this.setState({ fileDownloadSubmitted: true });

    RestApiUtils.get(
      this.props.context,
      `/api/su/messages/approvals/${messageApprovalId}/${fileName}/fileDownloadSignedUrl`,
      this.onDocDownloadClickCallback,
      null);
  };


  onDocDownloadClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      fileDownloadSubmitted: false
    });

    if (response.errorList.length === 0) {
      const link = document.createElement('a');
      link.href = response.signedUrl.signedUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  onSendClick = (event) => {
    if (this.state.sendSubmitted)
      return;

    let messageApprovalId = event.target.getAttribute('data-row-id');
    this.setState({
      sendSubmitted: true,
      sendErrorList: [],
      selectedMessageId: messageApprovalId
    });

    RestApiUtils.put(this.props.context,
      `/api/su/messages/approvals/${messageApprovalId}/approve`,
      this.onSendClickCallback, {}
    );
  }

  onSendClickCallback = (response) => {
    let errorList = [];
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message);
      });
    }

    this.setState({
      sendSuccessMsg: response.success,
      sendErrorList: errorList,
      sendSubmitted: false,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ sendSuccessMsg: null, sendErrorList: [] });
        this.onRefreshClick('noBusy');
      }, 2000);
    }
  }

  onSendNoticeToInternalClick = (event) => {
    if (this.state.internalSendSubmitted)
      return;

    let messageApprovalId = event.target.getAttribute('data-row-id');
    this.setState({
      internalSendSubmitted: true,
      internalSendErrorList: [],
      selectedMessageId: messageApprovalId
    });

    RestApiUtils.post(this.props.context,
      `/api/su/messages/approvals/${messageApprovalId}/emailToInternal`,
      this.onSendNoticeToInternalClickCallback, {}
    );
  }

  onSendNoticeToInternalClickCallback = (response) => {
    let errorList = [];
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message);
      });
    }

    this.setState({
      internalSendSuccessMsg: response.success,
      internalSendErrorList: errorList,
      internalSendSubmitted: false,
    });

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ internalSendSuccessMsg: null, internalSendErrorList: [] });
        this.onRefreshClick('noBusy');
      }, 2000);
    }
  }

  onDeleteClick = (event) => {

    if (this.state.deleteSubmitted)
      return

    let rowId = event.target.getAttribute('data-row-id');
    this.setState({
      deleteSubmitted: true,
      deleteErrorList: [],
      selectedMessageId: rowId
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/messages/approvals/${rowId}`,
      this.onDeleteClickCallback, {}
    )
  }

  onDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      deleteSuccessMsg: response.success,
      deleteErrorList: errorList,
      deleteSubmitted: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ deleteSuccessMsg: null, deleteErrorList: [] })
        this.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  onFileDeleteClick = (event) => {
    let messageApprovalId = event.target.getAttribute('data-message-id');
    let fileName = event.target.getAttribute('data-file-name')
    this.setState({
      deleteFileMode: true,
      selectedFile: fileName
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/messages/approvals/${messageApprovalId}/files/${fileName}`,
      this.onFileDeleteClickCallback, {}
    )
  }

  onFileDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteFileMode: false,
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null, errorList: [] })
        this.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.PendingMessageApprovals(this.state.year, this.state.month));
    if (noBusy === 'noBusy')
      this.getPendingMessageApprovals(context, this.state.year, this.state.month)
    else
      this.setState({
        errorList: null,
        pendingMessageList: null
      },
        this.getPendingMessageApprovals(context, this.state.year, this.state.month)
      )
  };
}

export default withRouter(PendingMessageApprovalListPageSF);
